module.exports = __webpack_public_path__ + "img/Custom.5e77e7b8.png";